import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { retry } from 'rxjs/operators';
import { AuthHttp } from '../http/http.service';
import { AuthenticationService } from '../auth/authentication.service';
import { requestWithFallback } from '../http/request-with-response';

@Injectable()
export class TicketBaiInfoService {
  constructor(private readonly http: AuthHttp, private readonly authService: AuthenticationService) {}

  getInfo(empresaId) {
    const url = `${environment.apiURLs.private}/eus/ticket_bai/obtener-info-mensaje-hacienda/${empresaId}`;
    return requestWithFallback(this.http.get(url).pipe(retry(2)), {
      cif_deipe: '-',
      nombre_software: '-',
      numero_inscripcion: '-',
      razon_social_deipe: '-',
      version: '-'
    });
  }
}
